<template>
  <div>
    <h2>这是<em>接口文档</em>画面！</h2>
  </div>
</template>

<script>

  export default {
    data() {
      return {

      }
    },
    methods: {
    },
    mounted() {
    }

  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/Sys/Document.vue